import { render } from "./3PembinaandanPengembanganKawasanTransmigrasi.vue?vue&type=template&id=0f19bb5c&scoped=true"
import script from "./3PembinaandanPengembanganKawasanTransmigrasi.vue?vue&type=script&lang=js"
export * from "./3PembinaandanPengembanganKawasanTransmigrasi.vue?vue&type=script&lang=js"

import "./3PembinaandanPengembanganKawasanTransmigrasi.vue?vue&type=style&index=0&id=0f19bb5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f19bb5c"]])

export default __exports__